import React, { useState } from 'react';
import './recommendedJobsDetail.css';
import useJobRecommender from '../../../../hooks/jobs/useJobRecommender';
import Slider from 'react-slick';
import RecommendJobDetailPostCard from './RecommendJobDetailPostCard/RecommendJobDetailPostCard';

const RecommendedJobsDetail = () => {
  const { items, loading, error } = useJobRecommender();
  const [activeIndex, setActiveIndex] = useState(0); 

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    beforeChange: (current, next) => setActiveIndex(next), 
    customPaging: (i) => (
      <div
        style={{
          width: '10px',
          height: '10px',
          borderRadius: '50%',
          backgroundColor: i === activeIndex ? '#fb5424' : 'lightgray', 
        }}
      ></div>
    ),
    appendDots: (dots) => (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '5px',
        }}
      >
        {dots.length > 5 ? dots.slice(0, 5) : dots} 
      </div>
    ),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error loading jobs: {error.message}</div>;
  }

  return (
    <div className="recommended-jobs-detail__container">
      <div className="recommended-jobs-detail__title-container">
        <h2> RECOMENDADOS PARA TI</h2>
        <h3>MÁS POSTULACIONES, MAYORES OPORTUNIDADES</h3>
      </div>
      
      <Slider {...settings}>
        {items.map((item) => (
          <div key={item.id}>
            <RecommendJobDetailPostCard data={item} />
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default RecommendedJobsDetail;


